import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header, Input, Dimmer, Button, Modal } from 'semantic-ui-react';
import HorizontalCards from '../HorizontalCards/HorizontalCards';
import { useSelector, useDispatch } from 'react-redux';
import { designActions, templateActions } from '../../actions';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './TemplateCategorized.css';
import TemplatePreview from '../TemplatePreview/TemplatePreview';

// eslint-disable-next-line no-unused-vars
const TemplateCategorized = ({ mobile, formShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(state => state.authentication.user);
  const hasSubscription = useSelector(state => state.subscription.hasSubscription);
  const templates = useSelector(state => state.template.templates);
  const loading = useSelector(state => state.template.status);
  const [activeDim, setActiveDim] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const selectedTemplateRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    dispatch(templateActions.search({ groupBy: 'categories', perGroupLimit: 15 }, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchKeyPress = event => {
    if (event.key === 'Enter') {
      dispatch(templateActions.search({ q: inputRef.current.value }, true));
      history.push(`/home/templates/tags/${inputRef.current.value}`);
    }
  };

  const createDesign = template => {
    if (_.get(template, 'data.pages', []).length > 1) {
      selectedTemplateRef.current = template;
      setShowPreview(true);
    } else {
      // Block action if template has price and user hadn't subscription
      if (user.role === 'client' && _.get(template, 'data.price', 0) > 0 && !hasSubscription) {
        setActiveDim(true);
        return;
      }

      dispatch(
        designActions.create({
          templateId: _.get(template, 'data.id'),
          templateCategory: _.get(template, 'data.categories', [''])[0],
        }),
      );
    }
  };

  return (
    <div className="templateCategorized">
      <div className="searchBanner">
        <Header
          as="h1"
          content={t('searchTemplates')}
          style={{
            fontSize: mobile ? '1.5em' : '2.5em',
            fontWeight: 'bold',
            marginTop: mobile ? '0.5em' : '1.5em',
            color: '#fff',
          }}
        />
        <Input
          className="searchField"
          icon="search"
          placeholder={`${t('search')}...`}
          onKeyPress={handleSearchKeyPress}
        >
          <input ref={inputRef} />
        </Input>
      </div>
      {loading !== 'loading' &&
        templates.map((templateGroup, index) => {
          return (
            <HorizontalCards
              key={index}
              parent="Startup"
              title={t(`tags:${templateGroup._id}`)}
              showMore={t('showMore')}
              itemType="templates"
              items={templateGroup.templates}
              height={200}
              onShowMoreClick={() => history.push(`/home/templates/categories/${templateGroup._id}`)}
              onItemSelect={template => createDesign(JSON.parse(template))}
            />
          );
        })}
      <Dimmer active={activeDim} blurring="true" className="attentionAlert">
        <Header as="h2" icon>
          {t('noSubscription')}
          <br />
        </Header>
        <div className="dimContent">
          <Button className="vButton colorPrimary" content={t('gotIt')} onClick={() => setActiveDim(false)} />
        </div>
      </Dimmer>

      <Modal size="large" open={showPreview} className="templatePreview" onClose={() => setShowPreview(false)}>
        <TemplatePreview template={selectedTemplateRef.current} />
      </Modal>
    </div>
  );
};

TemplateCategorized.propTypes = {
  mobile: PropTypes.any,
  formShow: PropTypes.any,
};

export default TemplateCategorized;
